module.exports = __webpack_public_path__ + "img/traditional.928ade95.png";